<template>
      <TheFooter>
        <div>
          <!--footer-->
          <!-- <a href="https://wt.org.in">Book of Turtles</a> -->
          Book of Turtles
          <span class="ml-1">&copy; 2020.</span>
        </div>
        <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="http://leopardtechlabs.com">Leopard Tech Labs Pvt. Ltd</a>
        </div>
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
}
</script>
